import api from './api';

export interface AppNotification {
  id: number;
  type: string;
  title: string;
  content?: string;
  related_post_id?: number;
  related_comment_id?: number;
  related_user_id?: number;
  is_read: boolean;
  created_at: string;
  related_post?: {
    id: number;
    title: string;
  };
  related_user?: {
    id: number;
    username: string;
    full_name?: string;
  };
}

export interface NotificationListResponse {
  notifications: AppNotification[];
  total: number;
  unread_count: number;
  page: number;
  per_page: number;
  pages: number;
}

export const notificationService = {
  getNotifications: async (params?: { page?: number; per_page?: number; unread_only?: boolean }) => {
    const response = await api.get<NotificationListResponse>('/notifications', { params });
    return response.data;
  },

  markAsRead: async (notificationId: number) => {
    const response = await api.post<{ message: string; notification: AppNotification }>(
      `/notifications/${notificationId}/read`
    );
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await api.post<{ message: string }>('/notifications/read-all');
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get<{ unread_count: number }>('/notifications/unread-count');
    return response.data;
  },
};

